module.exports = __webpack_public_path__ + "static/img/9.8cae36e.png";


//////////////////
// WEBPACK FOOTER
// ./static/ALL/9.png
// module id = +6YH
// module chunks = 202